import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import zhCN from './zh-CN';
import zhTW from './zh-TW';
import enUS from './en-US';
import ls from "../utils/ls";

const langs = {
  cn: {
    translation: zhCN,
  },
  tw: {
    translation: zhTW,
  },
  en: {
    translation: enUS,
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources: langs,
    fallbackLng: ls.get('MALLLANG') || 'tw',
    detection: {
      caches: ['localStorage', 'sessionStorage'],
    }
  });

export default i18n;
